import clsx from 'clsx';
import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import MobileSubMenuTabItems from './mobile-submenu-tab-items';

const MobileSubMenuTabs = ({
  menu,
  activeMenu,
  activeTab,
  setActiveTab,
  setActiveMenu,
}) => {
  const tabsHeadings = menu.map((m) => m.title);

  const submenu = useMemo(
    () => <MobileSubMenuTabItems menu={activeMenu} />,
    [activeMenu, activeTab],
  );

  return (
    <div className="flex flex-col items-start justify-start">
      <div className="w-full px-5 pt-[14px]">
        <div className="flex w-full rounded-[4px] border border-black-30 overflow-hidden ">
          {tabsHeadings.map((title, index) => (
            <div className='flex-[1_1_50%]' key={`${title}-${index}`}>
              <p
                className={clsx(
                  'cursor-pointer px-5 pt-4 pb-3 cta-small uppercase tracking-wide',
                  activeTab === index && 'text-black bg-cream-grey',
                  activeTab !== index && 'text-charcoal bg-neutral',
                )}
                onClick={() => {
                  setActiveTab(index);
                  setActiveMenu(menu[index].submenus);
                }}
              >
                {title}
              </p>
            </div>
          ))}
        </div>
      </div>
      {submenu}
    </div>
  );
};

export default MobileSubMenuTabs;
